import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 z-[100]",
  tabindex: "-1"
}

import { useModal } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  opened, component, data, close,
} = useModal();

return (_ctx: any,_cache: any) => {
  return (_unref(opened))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), _mergeProps(_unref(data), { close: _unref(close) }), null, 16, ["close"]))
      ]))
    : _createCommentVNode("", true)
}
}

})